import styled from 'styled-components';
import { MobileModalContent, MobileModalLayout, ModalBackground, ModalFooter } from 'components/Modal/ModalForms';
import MobileBasicButton from 'components/Buttons/MobileBasicButton';
import { BorderColor, TextColor } from 'styles/Global/colorSemantic';
import { MouseEvent } from 'react';
import { Body1Bold, Body3Medium, Caption1Regular } from 'styles/Global/typography';
import { Radius } from 'styles/Global/objectStyles';
import { formattedTimeNotFilter } from 'utils/calculateTime';
import IcCalendarPointColorBlue from 'assets/Icons/Calendar/IcCalendarPointColorBlue';
import { ConfirmDialogueSimpleInfoModalProps } from 'models/Modal/confirmDialogTypes';

const ConfirmDialogueSimpleInfo = ({ clickFirstButton, clickSecondButton, title, content, firstButton, secondButton, counselData }: ConfirmDialogueSimpleInfoModalProps) => {
    const handleBackgroundClick = (e: MouseEvent) => {
        // 클릭된 요소가 배경 자체인 경우에만 닫기
        if (e.target === e.currentTarget) {
            clickFirstButton();
        }
    };

    return (
        <ModalBackground $type='mobile' onClick={handleBackgroundClick}>
            <MobileModalLayout $gap='16px' $maxWidth='340px'>
                <ModalTitleAndContentContainer>
                    <Title>{title}</Title>
                    <MobileModalContent>{content}</MobileModalContent>
                </ModalTitleAndContentContainer>
                <Container>
                    <IcCalendarPointColorBlue />
                    <InfoText>{formattedTimeNotFilter(counselData?.reservationDate!)}</InfoText>
                </Container>
                <ModalFooter $marginTop='4px'>
                    <MobileBasicButton $width='100%' $height='52px' onClick={clickFirstButton} $type='gray'>
                        {firstButton}
                    </MobileBasicButton>
                    <MobileBasicButton $width='100%' $height='52px' onClick={clickSecondButton} $type='fill'>
                        {secondButton}
                    </MobileBasicButton>
                </ModalFooter>
            </MobileModalLayout>
        </ModalBackground>
    );
};

export default ConfirmDialogueSimpleInfo;

const ModalTitleAndContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 52px;
    border-radius: ${Radius.radius_8};
    padding: 0 16px;
    gap: 6px;
    border: 1px solid ${BorderColor.color_border_neutral};
`;

const Title = styled(Body1Bold)``;

const InfoLabel = styled(Caption1Regular)`
    width: 64px;
    color: ${TextColor.color_text_light};
`;

const InfoText = styled(Body3Medium)``;
